// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: gateway KONVO_AGENTS_UPDATE (sent to a machine's owner): machines changed, a machine's
// thread list changed, or a watched thread moved on. Parsed against the shared contract so a
// malformed frame never reaches the store.

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import Agents from '@app/features/konvo_agents/state/Agents';
import {Logger} from '@app/features/platform/utils/AppLogger';
import {AgentsUpdateEventSchema} from '@konvo/schema/src/domains/konvo/Agents';

const logger = new Logger('AgentsUpdate');

export function handleKonvoAgentsUpdate(data: unknown, _context: GatewayHandlerContext): void {
	const parsed = AgentsUpdateEventSchema.safeParse(data);
	if (!parsed.success) {
		logger.warn('Ignoring a malformed KONVO_AGENTS_UPDATE', parsed.error.issues[0]?.message);
		return;
	}
	Agents.applyEvent(parsed.data);
}
